import lodash from 'lodash';
import { createMeta } from '@exodus/trezor-meta';
export const getTrezorMeta = lodash.memoize((asset) => createMeta({
    [asset.name]: asset,
}), (asset) => asset.name);
